import { inject, Pipe, PipeTransform } from "@angular/core";

import { I18nService } from "../services/i18n.service";

// We might have switch to an impure pipe in the future https://angular.io/guide/pipes#pure-and-impure-pipes
@Pipe({
	name: "i18n",
	standalone: false,
})
export class I18nPipe implements PipeTransform {
	private i18nService = inject(I18nService);

	transform(value: string | { [language: string]: string }) {
		if (typeof value === "string" || typeof value === "number") {
			return value;
		}

		const language = this.i18nService.getLanguage();

		if (value[language]) {
			// Return the value in the correct language
			return value[language];
		}

		// Return the Dutch value or the first value
		return value.nl || value[Object.keys(value)[0]];
	}
}
